import { useEffect, useState } from "react";
import { Clock, Users, Wrench } from "lucide-react";
import { api } from "@/lib/api";

/** Bandeau honnêteté : « on fait des pauses, pas BKPROD » — l'app prend le relais bureau fermé. */
export const StatutHoraires = ({ compact = false }) => {
  const [h, setH] = useState(null);

  useEffect(() => {
    api
      .get("/horaires")
      .then(({ data }) => setH(data))
      .catch(() => setH(null));
  }, []);

  if (!h) return null;

  const ouvert = h.ouvert;
  const cadre = ouvert ? "border-emerald-200 bg-emerald-50" : "border-slate-200 bg-slate-50";

  if (compact) {
    return (
      <div className="flex items-center gap-2 text-xs text-slate-500" data-testid="horaires-compact">
        <span className={`h-2 w-2 rounded-full ${ouvert ? "bg-emerald-500" : "bg-slate-400"}`} />
        {ouvert ? "Bureau ouvert" : `Bureau fermé · reprise ${h.reprise_label}`} · {h.plages.join(" / ")} {h.jours}
      </div>
    );
  }

  return (
    <div className={`rounded-xl border px-4 py-3 space-y-2 ${cadre}`} data-testid="horaires-banner">
      <div className="flex items-center gap-2">
        <span className={`h-2.5 w-2.5 rounded-full ${ouvert ? "bg-emerald-500 animate-pulse" : "bg-slate-400"}`} />
        <span className="text-sm font-semibold text-slate-900" data-testid="horaires-etat">
          {ouvert ? "Bureau ouvert" : "Bureau fermé"}
        </span>
        {!ouvert && h.reprise_label && <span className="text-sm text-slate-600">· reprise {h.reprise_label}</span>}
      </div>

      <p className="text-sm text-slate-700" data-testid="horaires-message">
        {h.message} {!ouvert && h.message_app}
      </p>

      <div className="flex flex-wrap gap-x-5 gap-y-1 text-xs text-slate-500 pt-1">
        <span className="inline-flex items-center gap-1.5">
          <Clock size={13} /> {h.plages.join(" / ")} {h.jours}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <Users size={13} /> Nous, on fait des pauses — pas BKPROD
        </span>
        <span className="inline-flex items-center gap-1.5">
          <Wrench size={13} /> Souvent en intervention : l'app ne ferme jamais
        </span>
      </div>
    </div>
  );
};

export default StatutHoraires;
